import { BrowserRouter } from 'react-router-dom';
import './App.css';
import MainRouting from './components/MainRouting';



function App() {
  return (
    <>
      <BrowserRouter>
        <MainRouting/>
      </BrowserRouter>
    </>
  );
}

export default App;
